(() => {
  if (customElements.get('sl-cart-invoice')) return;
  const keys = ['company', 'nip', 'address', 'postcode', 'city', 'country'];
  let state, saved, pending, timer, message = '', hasError = false, edited = false, leaving = false;
  const resumed = new WeakSet();
  const widgets = () => [...document.querySelectorAll('sl-cart-invoice')];
  const normalize = value => value.trim().replace(/^PL\s*/i, '').replace(/[\s-]/g, '');
  function validNip(value) {
    const v = normalize(value);
    return /^\d{10}$/.test(v) && !/^(\d)\1{9}$/.test(v) && [6,5,7,2,3,4,5,6,7].reduce((s,w,i) => s+w*Number(v[i]),0)%11 === Number(v[9]);
  }
  function read(widget) {
    return Object.fromEntries([['enabled',widget.querySelector('[data-invoice-toggle]').checked], ...keys.map(k => [k,widget.querySelector(`[data-invoice-field="${k}"]`).value])]);
  }
  function attrs() {
    const a = {sl_invoice_requested: state.enabled ? '1' : ''};
    keys.forEach(k => a[`sl_invoice_${k}`] = state.enabled ? (k === 'nip' && state.country === 'PL' ? normalize(state[k]) : state[k].trim()) : '');
    return a;
  }
  function sync() {
    if (!state) return;
    document.documentElement.classList.toggle('sl-invoice-enabled', state.enabled);
    widgets().forEach(w => {
      const toggle = w.querySelector('[data-invoice-toggle]');
      toggle.checked = state.enabled;
      toggle.setAttribute('aria-expanded', String(state.enabled));
      const fields = w.querySelector('fieldset');
      fields.hidden = fields.disabled = !state.enabled;
      keys.forEach(k => {
        const input = w.querySelector(`[data-invoice-field="${k}"]`);
        if (input.value !== state[k]) input.value = state[k];
        input.setCustomValidity(k === 'nip' && state.enabled && state.country === 'PL' && state.nip && !validNip(state.nip) ? w.dataset.invalid : '');
      });
      const status = w.querySelector('[data-invoice-status]');
      if(status.textContent !== message) status.textContent = message;
      status.classList.toggle('is-error', hasError);
      w.setAttribute('aria-busy',String(!!pending));
    });
  }
  function say(key, error = false) { message = widgets()[0]?.dataset[key] || ''; hasError=error; sync(); }
  function complete() { return !state.enabled || keys.every(k => state[k].trim()) && (state.country !== 'PL' || validNip(state.nip)); }
  async function drain() {
    while (JSON.stringify(attrs()) !== saved) {
      const values = attrs();
      say('saving');
      const response = await fetch((window.Shopify?.routes?.root || '/')+'cart/update.js',{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:values}),signal:AbortSignal.timeout(15000)
      });
      if (!response.ok) throw new Error('invoice-save');
      const result=await response.json();
      if (!Object.entries(values).every(([k,v]) => (result.attributes?.[k] || '') === v)) throw new Error('invoice-readback');
      saved=JSON.stringify(values);
    }
  }
  function flush() {
    clearTimeout(timer);
    if (pending) return pending;
    if (JSON.stringify(attrs())===saved) return Promise.resolve();
    pending=drain().then(() => {pending=null;say(state.enabled?'saved':'removed');},error => {pending=null;saved=undefined;say('error',true);throw error;});
    sync();return pending;
  }
  function changed(event) {
    const w=event.target.closest('sl-cart-invoice');
    if(!w || !event.target.matches('[data-invoice-toggle],[data-invoice-field]')) return;
    state=read(w);edited=true;message='';hasError=false;sync();clearTimeout(timer);
    if(complete()) timer=setTimeout(() => flush().catch(()=>{}),350);
  }
  document.addEventListener('input',changed);
  document.addEventListener('change',changed);
  async function guard(event, cart, control, resume) {
    if(resumed.has(control)){resumed.delete(control);return;}
    if(!state || (!state.enabled && !edited)) return;
    if(event.defaultPrevented) return;
    event.preventDefault();event.stopImmediatePropagation();
    if(leaving || cart.classList.contains('sld-busy') || cart.hasAttribute('data-sld-uncertain') || cart.classList.contains('cart-form--refreshing')) return;
    const w=cart.querySelector('sl-cart-invoice');
    if(w) {state=read(w);sync();}
    if(!complete()) {
      say('incomplete',true);
      const invalid=[...w.querySelectorAll('[data-invoice-field]')].find(el=>!el.checkValidity());
      invalid?.reportValidity();invalid?.focus();return;
    }
    leaving=true;
    try {
      await flush();
      if(window.theme?.cartNoteMonitor?.flush) await window.theme.cartNoteMonitor.flush();
      resumed.add(control);resume();
    } catch {say('error',true);} finally {leaving=false;}
  }
  document.addEventListener('click',event => {
    const link=event.target.closest('cart-form .checkout-buttons a[href]');
    if(!link || event.button!==0 || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
    guard(event,link.closest('cart-form'),link,()=>link.click());
  },true);
  document.addEventListener('submit',event => {
    const form=event.target,cart=form.closest('cart-form');
    if(!cart || event.submitter?.name==='update') return;
    const submitter=event.submitter;
    guard(event,cart,form,()=>form.requestSubmit(submitter?.isConnected?submitter:undefined));
  },true);
  customElements.define('sl-cart-invoice',class extends HTMLElement {
    connectedCallback() {
      if(!state) {state=read(this);saved=JSON.stringify(attrs());}
      sync();
    }
  });
})();
